/**
 * Knack reveal-on-scroll.
 *
 * Progressive enhancement: adds `.is-revealed` to elements marked `[data-knack-reveal]` as they
 * enter the viewport (once each). Content is only hidden after this script runs (it adds
 * `knack-reveal-ready` to <html>), so if JS is off or motion is reduced, everything is visible.
 * No-ops entirely under prefers-reduced-motion. Pairs with the CSS in snippets/knack-reveal.liquid
 * and Horizon's existing --animation-easing var.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('knack-reveal-ready');

  const select = () => document.querySelectorAll('[data-knack-reveal]:not(.is-revealed)');
  const reveal = (el) => el.classList.add('is-revealed');

  if (!('IntersectionObserver' in window)) {
    select().forEach(reveal);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  const observeAll = () => select().forEach((el) => observer.observe(el));
  observeAll();

  // Re-scan when the Section Rendering API injects or updates sections (theme editor, dynamic loads).
  document.addEventListener('shopify:section:load', observeAll);
})();
